import { call, put, takeLatest } from 'redux-saga/effects';

import { RequestLogsAction } from './request-logs.state';

import requestLogsService from './request-logs.service';

import {
  FETCH_REQUEST_LOGS_API,
  fetchRequestLogsFailureApi,
  fetchRequestLogsSuccessApi,
} from './request-logs.action';

import { RequestLogsParams, RequestLogsResponse } from 'types/interface/request-logs.interface';

function* fetchRequestLogsApiCall(action: RequestLogsAction<RequestLogsParams>): Generator<any> {
  try {
    const resultRequestLogs = (yield call(
      requestLogsService.getRequestLogs,
      action.payload,
    ) as unknown) as RequestLogsResponse;
    yield put(fetchRequestLogsSuccessApi(resultRequestLogs));
  } catch (error) {
    yield put(fetchRequestLogsFailureApi(error));
  }
}

function* fetchRequestLogsSaga(): Generator<any> {
  yield takeLatest(FETCH_REQUEST_LOGS_API, fetchRequestLogsApiCall);
}

export { fetchRequestLogsApiCall };

export const requestLogsSaga = [fetchRequestLogsSaga()];
